<!-- Nivel 1 -->
<ng-container *ngIf="button.options.level === 1">
  <mat-expansion-panel [expanded]="true" class="level-1">
    <mat-expansion-panel-header class="expansion-header-group">
      <h4 class="title-group" [class.tw-pl-5]="!button?.icon">
        <mat-icon *ngIf="button?.icon" class="tw-pr-7"
          >{{ button?.icon }}
        </mat-icon>
        {{ button.data.name }}
      </h4>
    </mat-expansion-panel-header>

    <ng-container *ngIf="hasChildren">
      <mat-nav-list>
        <app-sidenav-btn
          *ngFor="let child of button.butons"
          [button]="child"
          [extraUrl]="button.data.appendUrl || '.'"
        ></app-sidenav-btn>
      </mat-nav-list>
    </ng-container>
  </mat-expansion-panel>
</ng-container>

<!-- Nivel 2 -->
<ng-container *ngIf="button.options.level === 2">
  <mat-expansion-panel class="level-2" [expanded]="button.data.active">
    <mat-expansion-panel-header
      class="not-group"
      [class.route-active]="button.data.active"
    >
      {{ button.data.name }}
    </mat-expansion-panel-header>

    <ng-container *ngIf="hasChildren">
      <mat-nav-list>
        <app-sidenav-btn
          *ngFor="let child of button.butons"
          [button]="child"
          [extraUrl]="button.data.appendUrl || '.'"
        ></app-sidenav-btn>
      </mat-nav-list>
    </ng-container>
  </mat-expansion-panel>
</ng-container>

<!-- Nivel 3 -->
<ng-container
  *ngIf="button.options.level === 3 || (!hasChildren && button.data.url)"
>
  <a
    mat-list-item
    [routerLink]="getLink()"
    (click)="onClick($event)"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{
      exact: button.data.exact === undefined ? true : button.data.exact
    }"
    [class.active-by-other-url]="button.data.active"
    [queryParams]="button.data.queryParams"
    class="level-3"
  >
    {{ button.data.name }}
  </a>
</ng-container>
